export const user = "USER"; // user
export const admin = "ADMIN";
